import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {RolesEnum} from '../../core/security/roles.enum';
import {debounceTime} from 'rxjs/operators';
import {Router} from '@angular/router';
import {SelectTemplateV2Datasource} from './select-template-v2.datasource';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import {MatDialog} from '@angular/material/dialog';
import {EditTemplateDialogComponent} from './edit-template-dialog.component';
import { MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldFix } from '../../editors/mat-form-field/mat-form-field-fix';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-messaging-select-template-v2',
    templateUrl: './select-template-v2.component.html',
    styleUrls: ['./select-template-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
    imports: [
        MatIconButton,
        MatTooltip,
        MatMenuTrigger,
        MatMenu,
        MatCard,
        MatCardContent,
        FlexModule,
        MatButtonToggleGroup,
        MatButtonToggle,
        MatSelectionList,
        CdkVirtualScrollViewport,
        CdkFixedSizeVirtualScroll,
        CdkVirtualForOf,
        MatListOption,
        NgIf,
        MatIcon,
        MatCardActions,
        MatFormFieldFix,
        MatFormField,
        MatLabel,
        MatInput,
        FormsModule,
        MatMiniFabButton,
        MatSuffix,
    ],
})
export class SelectTemplateV2Component implements OnInit, OnDestroy {

  @Output() selectedEvent: EventEmitter<any> = new EventEmitter();

  show = false;
  loading = false;

  filterType: '0' | '1' | '2' = '0';
  searchText = '';
  searchTextSubscription: Subscription;
  searchTextSubject = new BehaviorSubject<string>('');

  hasViewAccess = false;
  hasEditAccess = false;
  hasPrivateEditAccess = false;

  @ViewChild('triggerMenu') triggerMenu: MatMenuTrigger;

  constructor(
    public templatesDataSource: SelectTemplateV2Datasource,
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService) {

    this.hasViewAccess = this.authService.hasAccess([
      RolesEnum.MessagingTemplateView,
      RolesEnum.MessagingTemplateEdit,
      RolesEnum.MessagingTemplateDelete,
      RolesEnum.MessagingPrivateTemplateView,
      RolesEnum.MessagingPrivateTemplateEdit,
      RolesEnum.MessagingPrivateTemplateDelete,
    ]);

    this.hasEditAccess = this.authService.hasAccess([
      RolesEnum.MessagingTemplateEdit,
      RolesEnum.MessagingTemplateDelete,
    ]);
    this.hasPrivateEditAccess = this.authService.hasAccess([
      RolesEnum.MessagingPrivateTemplateEdit,
      RolesEnum.MessagingPrivateTemplateDelete,
    ]);
  }

  click() {
    this.triggerMenu.openMenu();
  }

  onItemClick($event, dataItem) {
    if (this.selectedEvent) {
      this.selectedEvent.emit(dataItem.message);
    }
  }

  async getTemplates(): Promise<void> {
    this.loading = true;

    try {
      this.templatesDataSource.searchTextEmitter.emit({
        searchText: this.searchText,
        type: this.filterType,
      });
    } finally {
      this.loading = false;
    }
  }

  ngOnInit() {
    this.searchTextSubscription = this.searchTextSubject
      .pipe(debounceTime(500))
      // .pipe(distinctUntilChanged())
      .subscribe(async (value) => {
        console.log(value);
        if (this.searchText !== value) {
          this.searchText = value;
          await this.getTemplates();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.searchTextSubscription) {
      this.searchTextSubscription?.unsubscribe();
    }
  }

  onSearchChange($event: string) {
    this.searchTextSubject.next($event);
  }

  filterByType($event: MouseEvent, number: '0' | '1' | '2') {
    $event.stopPropagation();
    this.filterType = number;
    console.log('filterByType', this.filterType);
    // this.filterType = number;
    this.getTemplates();
  }

  editTemplate($event: MouseEvent, id: string) {
    $event.stopPropagation();
    this.triggerMenu.closeMenu();

    const dialogRef = this.dialog.open(EditTemplateDialogComponent, {
      width: '500px',
      data: {editId: id}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        if (this.selectedEvent) {
          this.selectedEvent.emit(result.message);
        }
      }
    });
  }

  menuOpened() {
    this.getTemplates();
    window.dispatchEvent(new Event('resize'));
  }
}
